import Vue from "vue";
import VueRouter from "vue-router";
import OidcCallback from "@/views/OidcCallback.vue";
import {vuexOidcCreateRouterMiddleware} from "vuex-oidc";
import store from "@/store"

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Dashboard",
        component: () => import("@/views/Dashboard.vue"),
    },
    {
        path: "/deployment/new",
        name: "Deployment",
        component: () => import("@/views/NewDeploymentView.vue")
    },
    {
        path: '/oidc-callback',
        name: 'oidcCallback',
        component: OidcCallback
    }
];

const router = new VueRouter({
    mode: 'history',
    routes: routes
});
router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'));

export default router;
